export function shortenTokenName(token: string) {
  const tokenLength = token.length
  if (tokenLength > 30) {
    return `${token.slice(0, 10)}...`
  } else {
    return token
  }
}

export const isHighSlippage = (slippage: number, maxSlippage: string) =>
  slippage < 0 && Math.abs(slippage) > Number(maxSlippage)

export const isBonus = (slippage: number) => Number(slippage) > 0

export function fulfilledValue<T>(result: PromiseSettledResult<T>) {
  if (result.status === 'fulfilled') {
    return result.value
  } else {
    console.error(result.reason)
  }
}

export const delayAction = <T extends () => unknown>(cb: T) => setTimeout(() => cb(), 50)
